import { getDelegationTokenForOwa } from 'owa-tokenprovider';
import { isSuccessStatusCode } from 'owa-http-status-codes';
import { getUserCulture } from 'owa-session-store';
import { trace } from 'owa-trace';
import { format } from 'owa-localize';
import { ArcApiResponse } from './schema/arcApiResponse';
import { isFeatureEnabled } from 'owa-feature-flags';

const ARC_ENPOINT =
    'https://arc.msn.com/v4/api/selection?placement={0}&country={1}&locale={2}&nct=1';
const placementId = getPlacementId();
const locale = getUserCulture();
const TOKEN_SCOPE = 'service::ads.arcct.msn.com::MBI_SSL';

export async function makeArcCall(): Promise<ArcApiResponse> {
    let headers = new Headers();
    let token = await getDelegationTokenForOwa(TOKEN_SCOPE);
    headers.append('authorization', `WLID1.1 t=${token}`);
    const request: RequestInit = {
        method: 'GET',
        headers: headers,
    };
    // Split the locale with a - and get the last two letter which is mostly the country code
    let country = '';
    if (locale) {
        country = locale.split('-').pop();
    }
    return fetch(format(ARC_ENPOINT, placementId, country, locale), request).then(handleResponse);
}

export async function makeBeaconCall(uri: string, beaconName: string) {
    const request: RequestInit = {
        method: 'GET',
    };

    //Replace the content between {ACTION} with beaconname.
    var formattedUri = uri.replace(new RegExp('{' + 'ACTION' + '}'), beaconName);
    fetch(formattedUri, request).then(handleResponse);
}

export async function makeImpressionCall(uri: string) {
    const request: RequestInit = {
        method: 'GET',
    };
    fetch(uri, request).then(handleResponse);
}

const handleResponse = (r: Response) => {
    if (!isSuccessStatusCode(r.status)) {
        trace.warn('Failed to make iris api call with response ' + r.status + r.statusText);
    }
    return r.json();
};

function getPlacementId(): string {
    if (isFeatureEnabled('auth-EnableIrisTestCampaign')) {
        return '88000363';
    }
    return '88000364';
}
